import { useState } from "react";
import { Avatar, Button, Col, Row, Typography, message } from "antd";
import {
  MailOutlined,
  PhoneOutlined,
  IdcardOutlined,
  SafetyCertificateOutlined,
  UnlockOutlined,
} from "@ant-design/icons";

import { UserByOrder } from "../../../../redux/@types";
import { WrapperCardUserOrder } from "../styled";
import { usersService } from "../../../../shared/services";
import { ModalUnlockUser } from "../../../../shared/components";

const { Title } = Typography;

export interface ShippingProps {
  id: number;
  name: string;
  address: string;
  user_id: number;
  city_id: number;
  state_id: number;
  lat: null;
  lng: null;
  details: string;
  main: string;
  integration_nit: null;
  integration_codigo_direccion: null;
  deletedAt: null;
  createdAt: Date;
  updatedAt: Date;
  address_name: string;
  address_id: number;
  state_name: string;
  state_integration_id: string;
  city_name: string;
  city_integration_id: string;
  dane_code: string;
  fulfillment_company_id: number;
}
interface Props {
  dataUser: UserByOrder;
  shipping: ShippingProps;
  clientIp?: string | null;
  userId?: number;
  onUserUnlocked?: () => void;
}

export const InfoUserCard = ({
  shipping,
  dataUser,
  clientIp,
  userId,
  onUserUnlocked,
}: Props) => {
  const [unlockOpen, setUnlockOpen] = useState(false);
  const [unlocking, setUnlocking] = useState(false);
  const unlockUserId = userId || dataUser.id;

  const unlockUser = async (reason: string) => {
    if (!unlockUserId) {
      message.error("No se encontró el id del usuario");
      return;
    }
    if (!reason) {
      message.warning("Indica el motivo del desbloqueo");
      return;
    }
    setUnlocking(true);
    try {
      await usersService.patch(unlockUserId, {
        status: "active",
        unlocked_reason: reason,
      });
      message.success("Usuario desbloqueado");
      setUnlockOpen(false);
      onUserUnlocked?.();
    } catch (err: any) {
      message.error(err?.message || "No se pudo desbloquear el usuario");
    } finally {
      setUnlocking(false);
    }
  };

  return (
    <WrapperCardUserOrder>
      <Row justify="start" style={{ width: "100%" }}>
        <Col
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            flexDirection: "column",
          }}
        >
          <Avatar
            size={74}
            style={{
              background: "var(--text-color-blue-dark)",
            }}
            src={`../../../../../public/avatar.png`}
          />
        </Col>
        <Col
          style={{
            display: "flex",
            marginLeft: "5px",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            flexDirection: "column",
          }}
        >
          <Title style={{ margin: 0, color: "var(--primary)" }} level={4}>
            {`${dataUser.first_name} ${dataUser.last_name}`}
          </Title>
          <Title
            style={{
              margin: 0,
              color: "var(--text-color-grey)",
            }}
            level={5}
          >
            <MailOutlined /> {`${dataUser.email}`}
          </Title>
          <Title
            style={{
              margin: 0,
              color: "var(--text-color-grey)",
            }}
            level={5}
          >
            <PhoneOutlined /> {`${dataUser.phone}`}
          </Title>
          <Title
            style={{
              margin: 0,
              color: "var(--text-color-grey)",
            }}
            level={5}
          >
            <IdcardOutlined />{" "}
            {`${dataUser.dni_type === "cedula" ? "cédula" : dataUser.dni_type} #${
              dataUser.dni
            }${
              dataUser.dni_type === "nit"
                ? ` - ${dataUser.company_legal_name}`
                : ""
            }`}
          </Title>
          {(clientIp || dataUser.ip_address_last) && (
            <Title
              style={{
                margin: 0,
                color: "var(--text-color-grey)",
              }}
              level={5}
            >
              <SafetyCertificateOutlined /> IP pedido:{" "}
              {clientIp || dataUser.ip_address_last || "—"}
              {dataUser.ip_address_last
                ? ` · Última IP usuario: ${dataUser.ip_address_last}`
                : ""}
            </Title>
          )}
          {dataUser.status && (
            <Title
              style={{
                margin: "4px 0 0",
                color:
                  dataUser.status === "pending security verification"
                    ? "#cf1322"
                    : "var(--text-color-grey)",
              }}
              level={5}
            >
              Estado: {dataUser.status}
              {dataUser.disabled_reason
                ? ` — ${dataUser.disabled_reason}`
                : ""}
            </Title>
          )}
          {(dataUser.unlocked_reason || dataUser.unlocked_by_name) && (
            <Title
              style={{
                margin: "4px 0 0",
                color: "var(--text-color-grey)",
              }}
              level={5}
            >
              Desbloqueo: {dataUser.unlocked_reason || "—"}
              {dataUser.unlocked_by_name
                ? ` · ${dataUser.unlocked_by_name}`
                : ""}
            </Title>
          )}
          {dataUser.status === "pending security verification" && (
            <Button
              type="primary"
              icon={<UnlockOutlined />}
              size="small"
              style={{ marginTop: 8 }}
              onClick={() => setUnlockOpen(true)}
            >
              Desbloquear usuario
            </Button>
          )}
        </Col>
      </Row>
      <Row justify="start" style={{ width: "100%" }}>
        <Col
          span={24}
          style={{
            display: "flex",
            marginLeft: "5px",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            flexDirection: "column",
          }}
        >
          <Title style={{ margin: "7px 0", color: "var(--primary)" }} level={4}>
            Datos de envío
          </Title>
        </Col>
        <Col
          style={{
            display: "flex",
            marginLeft: "5px",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            flexDirection: "column",
          }}
        >
          <Title
            style={{
              margin: 0,
              color: "var(--text-color-grey)",
            }}
            level={5}
          >{`${shipping.address}`}</Title>
          <Title
            style={{
              margin: 0,
              color: "var(--text-color-grey)",
            }}
            level={5}
          >{`Detalles: ${shipping.details}`}</Title>
          <Title
            style={{
              margin: 0,
              color: "var(--text-color-grey)",
            }}
            level={5}
          >
            {`${shipping.city_name}, ${shipping.state_name}`}
          </Title>
        </Col>
      </Row>
      <ModalUnlockUser
        user={
          unlockOpen && unlockUserId
            ? {
                id: unlockUserId,
                first_name: dataUser.first_name,
                last_name: dataUser.last_name,
              }
            : null
        }
        loading={unlocking}
        onCancel={() => setUnlockOpen(false)}
        onConfirm={unlockUser}
      />
    </WrapperCardUserOrder>
  );
};
